export const requestProxy: [unknown, string] = [{
  priority: 0,
  requestOptions: (args: any) => ({ ...args, credentials: 'include' }),
}, 'request-proxy'];
